module.exports = __webpack_public_path__ + "static/img/red.bcba0da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bodyparts/4/red.png
// module id = rY7b
// module chunks = 94